import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import { Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";

/* export const getUsuarios = async (setIsLoading, setUsuarios) => {
  setIsLoading(true);
  const result = await axios().get("get_usuarios");
  const { data, error } = result.data;
  if (data) {
    setUsuarios(data);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
}; */

export const hacerInspector = async (userInfo, setUserInfo) => {
  const result = await axios().post("inspector", { id: userInfo.id, dni: userInfo.dni });
  const { data, error } = result.data;
  if (data) {
    setUserInfo(data.data);
    toast.success("Usuario agregado como inspector", toastOptions);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
};

export const getPersonInfo = async (submittedData, setUserInfo, setIsLoading) => {
  setIsLoading(true);
  setUserInfo(null);
  const result = await axios().post("get_person_info", submittedData);
  const { data, error } = result.data;
  if (data) {
    setUserInfo(data);
  }
  if (error) {
    toast.error("Problemas para obtener la informacion de la persona. Por favor, intente nuevamente", toastOptions);
    setUserInfo(null);
  }
  setIsLoading(false);
};

export const toggleRolInspector = async (userInfo, setUserInfo, setIsLoadingToggle) => {
  setIsLoadingToggle(true);
  const result = await axios().post("toggle_rol_inspector", { id: userInfo.id, dni: userInfo.dni });
  const { data, error } = result.data;
  if (data) {
    setUserInfo(data.data);
    toast.success("Rol modificado correctamente", toastOptions);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoadingToggle(false);
};

export const onSubmitCreate = async (submittedData, setIsLoading, setAddUserFormIsOpen, setSearchUserModalIsOpen) => {
  setIsLoading(true);
  const result = await axios().post(`create_usuario_inspector`, submittedData);
  const { status } = result;
  const { data, error } = result.data;
  if (data) {
    setSearchUserModalIsOpen(false);
    toast.success("Usuario creado con exito", toastOptions);
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setIsLoading(false);
};

export const onSubmitEdit = async (submittedData, setIsLoading, setEditModalIsOpen) => {
  setIsLoading(true);
  const result = await axios().post(`edit_usuario`, submittedData);
  const { status } = result;
  const { data, error } = result.data;
  if (data) {
    toast.success("Contraseña cambiada correctamente", toastOptions);
    setEditModalIsOpen(false);
  }
  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setIsLoading(false);
};

export const userSchema = yup.object({
  id: yup.number().required("ID requerido").typeError("El ID debe ser un numero"),
  password: yup.string().required("La contraseña es requerida").max(255, "Maximo 255 caracteres"),
  repeatPassword: yup
    .string()
    .required("La contraseña es requerida")
    .max(255, "Maximo 255 caracteres")
    .oneOf([yup.ref("password"), null], "Las contraseñas deben ser iguales"),
});

export const searchUserSchema = yup.object({
  dni: yup
    .number()
    .integer("El DNI no debe contener puntos ni comas")
    .required("Documento requerido")
    .test("len", "El DNI debe ser de 8 caracteres", (val) => val.toString().length === 8)
    .typeError("El DNI debe ser un numero sin puntos ni comas"),
});

export const tableData = (data, setSelectedRow, setEditUserModalIsOpen) => {
  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            <Box className='mx-1'>
              <Button
                onClick={() => {
                  setSelectedRow(params.row);
                  setEditUserModalIsOpen(true);
                }}
              >
                <VisibilityIcon />
              </Button>
            </Box>
            <Box className='mx-1'>
              <Button
                onClick={() => {
                  setSelectedRow(params.row);
                  setEditUserModalIsOpen(true);
                }}
              >
                <EditIcon />
              </Button>
            </Box>
          </>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return d.id?.toString().toLowerCase().includes(value);
  };

  return { columns, rows, filter };
};
